import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { Subscription } from 'rxjs'
import { Pattern } from 'src/app/shared/constants/patterns.constant'
import { AuthService } from 'src/app/modules/auth/services/auth.service'
import { TranslateService } from '@ngx-translate/core'
import { Router } from '@angular/router'
import { environment } from 'src/environments/environment'
import { ToastrService } from 'ngx-toastr'

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit, OnDestroy {
	attachmentUrl = environment.attachmentPath
	hide: boolean = true

	loginForm: FormGroup = new FormGroup({})
	subscription: Subscription = new Subscription()

	signInObject: any = {}
	currentLang = ''
	constructor(
		private authServ: AuthService,
		private router: Router,
		public translate: TranslateService,
		private toaster: ToastrService
	) {}

	ngOnInit(): void {
		this.initForm()
	}

	initForm() {
		this.loginForm = new FormGroup({
			EmailAddress: new FormControl('', [
				Validators.required,
				Validators.pattern(Pattern.email),
			]),

			password: new FormControl('', [Validators.required]),
			deviceToken: new FormControl(null),
		})
	}

	login() {
		this.currentLang = this.translate.currentLang
		const BODY = { ...this.loginForm.getRawValue(), rememberClient: true }
		this.subscription.add(
			this.authServ.login(BODY, this.currentLang).subscribe({
				next: (res: any) => {
					this.authServ.storeData(res)
				},
			})
		)
	}

	getController(controlName: string) {
		return this.loginForm.controls[controlName] as FormControl
	}

	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
